import styled from "styled-components";

export const MainBody = styled.div`
    flex: 1;
    padding-top: 3rem;
    padding-bottom: 3rem;
    background-color: #f9fafb;
    `